module.exports = __webpack_public_path__ + "img/flower2.58fd2c85.svg";